import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Sticky } from 'react-sticky';

export { StickyContainer } from 'react-sticky';

const NavBarList = styled.ul.attrs({
  className: 'medium-horizontal menu bg-white align-middle',
})`
  &&& {
    flex-wrap: nowrap;
    overflow: auto;
    white-space: nowrap;
  }
`;

const TopBar = styled.div`
  && {
    border-top: 1px solid;
  }
`;

const NavBarRightMenuItem = styled.li`
  &&& {
    flex-basis: 0;
  }
`;

export const NavBarItem = styled.li``;

export const NavBarRightSection = ({ children }) => (
  <NavBarRightMenuItem className="top-bar-right p-0 pl-s">
    <NavBarList>
      { children }
    </NavBarList>
  </NavBarRightMenuItem>
);

NavBarRightSection.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

NavBarRightSection.defaultProps = {
  children: [],
};

const NavBar = ({
  sticky,
  children,
  topOffset,
  bottomOffset,
  itemsContainerClass,
  className,
  stickyContainerClass,
}) => {
  const content = (
    <TopBar className="top-bar border-global-separator-400 p-0 bg-white">
      <div className={`flex-container ${itemsContainerClass}`}>
        <div className="top-bar-left">
          <NavBarList className="pt-xs pb-xs">
            { children }
          </NavBarList>
        </div>
      </div>
    </TopBar>
  );
  return (
    sticky
      ? (
        <div className={stickyContainerClass}>
          <Sticky
            topOffset={-topOffset}
            bottomOffset={bottomOffset}
          >
            {({ style, isSticky }) => (
              <div
                className={`${className} ${isSticky ? 'is-sticky' : ''}`}
                style={{ ...style, top: topOffset + (style.top || 0), zIndex: 9 }}
              >
                { content }
              </div>
            )}
          </Sticky>
        </div>
      )
      : (
        <div className={className}>
          { content }
        </div>
      )
  );
};

NavBar.propTypes = {
  sticky: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  topOffset: PropTypes.number,
  bottomOffset: PropTypes.number,
  itemsContainerClass: PropTypes.string,
  className: PropTypes.string,
  stickyContainerClass: PropTypes.string,
};

NavBar.defaultProps = {
  sticky: false,
  children: [],
  topOffset: 0,
  bottomOffset: 0,
  itemsContainerClass: '',
  className: '',
  stickyContainerClass: '',
};
export default NavBar;
